import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root nicht gefunden");

/**
 * STAGING-Banner (Audit 2026-07-19, Befund H2/K2): Auf der Staging-Umgebung ist jederzeit
 * sichtbar, dass man NICHT im Live-System arbeitet. Gesetzt wird VITE_ENVIRONMENT="staging"
 * ausschliesslich vom Build-Schritt in .github/workflows/staging-deploy.yml — im Prod-Build
 * fehlt die Variable und der Banner existiert nicht (kein Laufzeit-Overhead, tree-shakebar).
 * pointer-events:none — der Balken faengt keine Klicks ab.
 */
const isStagingBuild = import.meta.env.VITE_ENVIRONMENT === "staging";

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    {isStagingBuild && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 2147483647,
          height: 22,
          lineHeight: "22px",
          textAlign: "center",
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: "0.08em",
          color: "#fff",
          background: "repeating-linear-gradient(45deg, #ea580c, #ea580c 12px, #c2410c 12px, #c2410c 24px)",
          pointerEvents: "none",
        }}
      >
        ⚠ STAGING — TESTSYSTEM · KEINE ECHTEN MAILS / ZAHLUNGEN / RECHNUNGEN
      </div>
    )}
    <App />
  </React.StrictMode>,
);
